<ng-container *ngIf="itinerary">
  <lms-breadcrumb [label]="itinerary.title || itinerary.name"></lms-breadcrumb>

  <ng-container *ngIf="isItineraryEditable; else readonlyMode">
    <div *ngIf="hasItineraryActions" class="gl-context-menu__position">
      <lms-button-actions>
        <div class="gl-context-menu__options">
          <ng-container *ngIf="canWithdrawItinerary">
            <span
              class="gl-context-menu__options--item"
              *lmsProfileGuard="'training.itineraries.withdrawItinerary'"
              (click)="modalWithdrawItinerary.open()"
              >{{ 'actions.withdrawItinerary' | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="canReactivateItinerary">
            <span
              class="gl-context-menu__options--item"
              *lmsProfileGuard="'training.itineraries.withdrawItinerary'"
              (click)="modalReactivateItinerary.open()"
            >
              {{ 'itineraries.config.reactivateItinerary' | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="isItineraryRemovable">
            <span
              class="gl-context-menu__options--item alert"
              *lmsProfileGuard="'training.itineraries.delete'"
              (click)="modalDeleteItinerary.open()"
              >{{ 'itineraries.deleteItinerary' | translate }}
            </span>
          </ng-container>
        </div>
      </lms-button-actions>
    </div>

    <mat-tab-group
      class="tab-group"
      #tabGroup
      animationDuration="0ms"
      disableRipple="true"
      (selectedTabChange)="setTab($event)"
    >
      <mat-tab label="config">
        <ng-template mat-tab-label>{{ 'itineraries.tabs.config' | translate }}</ng-template>
        <ng-template matTabContent>
          <lms-itinerary-editor (onSave)="onSave($event)" [itinerary]="itinerary">
            <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="goBack()" form-actions-before>
            </gl-button>
          </lms-itinerary-editor>
        </ng-template>
      </mat-tab>

      <mat-tab label="translate">
        <ng-template mat-tab-label>{{ 'itineraries.tabs.translate' | translate }}</ng-template>
        <ng-template matTabContent>
          <lms-itinerary-translations [itinerary]="itinerary">
            <gl-button
              color-secondary
              text="{{ 'actions.cancel' | translate }}"
              (onClick)="goBack()"
              form-actions-before
            ></gl-button>
          </lms-itinerary-translations>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-template #readonlyMode>
    <lms-itinerary-editor (onSave)="onSave($event)" [itinerary]="itinerary">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="goBack()" form-actions-before>
      </gl-button>
    </lms-itinerary-editor>
  </ng-template>

  <!-- Confirm delete itinerary modal -->
  <lms-modal #modalDeleteItinerary>
    <div class="gl-popup__title">{{ 'itineraries.notification.titleDelete' | translate }}</div>
    <div class="gl-popup__close" (click)="modalDeleteItinerary.close()">
      <span class="glicon-close"></span>
    </div>

    <div
      class="gl-popup__text"
      [innerHTML]="'itineraries.notification.textDelete' | translate : { itineraryName: itinerary.name }"
    ></div>

    <div class="gl-popup__text">{{ 'itineraries.notification.messageDelete' | translate }}</div>
    <div class="gl-popup__buttons">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalDeleteItinerary.close()">
      </gl-button>
      <gl-button color-primary [text]="'actions.delete' | translate" (onClick)="deleteItinerary()"> </gl-button>
    </div>
  </lms-modal>

  <!-- Confirm withdraw itinerary modal -->
  <lms-modal #modalWithdrawItinerary>
    <div class="gl-popup__title gap-bottom">{{ 'itineraries.withdraw.confirm.title' | translate }}</div>
    <div class="gl-popup__close" (click)="modalWithdrawItinerary.close()">
      <span class="glicon-close"></span>
    </div>

    <div class="gl-popup__text">{{ 'itineraries.withdraw.confirm.description' | translate }}</div>
    <div class="gl-popup__text">
      <b>{{ 'itineraries.withdraw.confirm.descriptionBold' | translate }}</b>
    </div>

    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalWithdrawItinerary.close()">
      </gl-button>
      <gl-button
        color-primary
        [text]="'actions.withdrawItinerary' | translate"
        (onClick)="toggleWithdrawItinerary(true)"
      ></gl-button>
    </div>
  </lms-modal>

  <!-- Confirm reactivate itinerary modal -->
  <lms-modal #modalReactivateItinerary size="small">
    <div class="gl-popup__title gap-bottom">{{ 'itineraries.config.confirmReactivation' | translate }}</div>
    <div class="gl-popup__close" (click)="modalReactivateItinerary.close()">
      <span class="glicon-close"></span>
    </div>

    <div class="gl-popup__text">{{ 'itineraries.config.reactivateItineraryDescription' | translate }}</div>

    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalReactivateItinerary.close()">
      </gl-button>
      <gl-button
        color-primary
        [text]="'itineraries.config.reactivateItinerary' | translate"
        (onClick)="toggleWithdrawItinerary(false)"
      ></gl-button>
    </div>
  </lms-modal>

  <!-- Error reactivating itinerary modal -->
  <lms-modal #modalErrorReactivatingItinerary size="small">
    <div class="gl-popup__icon error centered">
      <span class="glicon-alert-thin"></span>
    </div>

    <div class="gl-popup__title gap-bottom">{{ 'itineraries.config.reactivateItineraryErrorTitle' | translate }}</div>
    <div class="gl-popup__close" (click)="modalErrorReactivatingItinerary.close()">
      <span class="glicon-close"></span>
    </div>

    <div class="gl-popup__text">{{ 'itineraries.config.reactivateItineraryErrorDescription' | translate }}</div>

    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button
        color-primary
        [text]="'actions.gotIt' | translate"
        (onClick)="modalErrorReactivatingItinerary.close()"
      ></gl-button>
    </div>
  </lms-modal>
</ng-container>
